import * as React from 'react';
export const JMSvg = React.forwardRef(function JMSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
        transform: 'translate(0 2)',
      },
      /*#__PURE__*/ React.createElement('rect', {
        width: 16,
        height: 12,
        fill: '#FCD669',
        rx: 2,
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#A68527',
        fillOpacity: 0.1,
        fillRule: 'nonzero',
        d: 'M2 0a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2v-1a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1V0Zm12 0a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2v-1a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1V0Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#24B47E',
        d: 'M1.994 0h12.012c.557 0 1.061.23 1.423.602L8 4.5.868.496A1.713 1.713 0 0 1 .762.43C1.1.16 1.529 0 1.994 0Zm12.012 12H1.994c-.465 0-.893-.16-1.233-.43.032-.022.068-.044.107-.066L8.001 7.5l7.13 4.004c.04.022.075.044.107.066-.339.269-.767.43-1.232.43Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#333',
        d: 'm0 3 6 3-6 3V3Zm16 0v6l-6-3 6-3Z',
      }),
    ),
  );
});
JMSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var JM = {
  category: 'flag',
  colorable: false,
  name: 'JM',
  svg: JMSvg,
};
